import { render, staticRenderFns } from "./LiquidDemandDataPrice.vue?vue&type=template&id=91348d32&scoped=true&"
import script from "./LiquidDemandDataPrice.vue?vue&type=script&lang=js&"
export * from "./LiquidDemandDataPrice.vue?vue&type=script&lang=js&"
import style0 from "./LiquidDemandDataPrice.vue?vue&type=style&index=0&id=91348d32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91348d32",
  null
  
)

export default component.exports